export const navigation = [
  {
    text: 'Home',
    path: '/home',
    icon: 'fas fa-home'
  },
  {
    text: 'Templates',
    path: '/templates',
    icon: 'fas fa-file-invoice'
  },
  {
    text: 'Documents',
    path: '/documents',
    icon: 'fas fa-file-alt'
  },
];
